function base() {
    var base = new Object()
    base.formatDate = formatDate   // 时间戳转日期
    base.formatDateTime = formatDateTime;  //时间戳转日期（包含时分）
    base.numFilter = numFilter;     // 截取当前数据到小数点后两位，小数点后两位为0就直接去掉
    base.getLocalTime = getLocalTime;
    base.base_localStorage = base_localStorage;
    return base
}


//本地localStorage缓存相关（只处理{expirationTime:time,data:data}这种格式 ）
let base_localStorage = {
	set({key,time=0,data} = {}){//key键;time过期时间,0为永久，单位分钟;data内容
		if(key){
			if(time != 0){
				let date = new Date();
				date.setMinutes(date.getMinutes () + time);
				time = timeStr(date,'yyyy/MM/dd hh:mm:ss');
			}
			let obj = {expirationTime:time,data:data};
			localStorage.setItem(key,JSON.stringify(obj));
			return obj;
		}
		console.error('存放缓存错误：',key,time,data);
	},
	//数据为数组时的处理
	//key键;time过期时间,0为永久，
	//listItem内容
	//length最多可存放的长度,0时不处理,
	//length 大于0时处理;处理的逻辑例子：[1,2,3,4,5],此时有新增值6时，[6,1,2,3,4];相当于删除最旧的值;
	setList_add({key,time=0,listItem,length=0} = {}){
		if(key){
			let tempItem = JSON.parse(localStorage.getItem(key)||'{"data":[]}').data;
			if(time != 0){
				let date = new Date();
				date.setMinutes(date.getMinutes () + time);
				time = timeStr(date,'yyyy/MM/dd hh:mm:ss');
			}
			if(length != 0&&tempItem.length >= length){
				tempItem.pop();
				tempItem.unshift(listItem);
			}else{
				tempItem.unshift(listItem);
			}
			let obj = {expirationTime:time,data:tempItem};
			localStorage.setItem(key,JSON.stringify(obj));
			return obj;
		}
		console.error('存放缓存错误：',key,time,listItem);
	},
	get(key,{judgeTime = true,removeData = true} = {}){//key键;{judgeTime判断是否过期;removeData过期是否从缓存中删除}
		let item = localStorage.getItem(key);
		if(item){
			item = JSON.parse(item);
			if(judgeTime&&item.expirationTime != 0){
				if(new Date(item.expirationTime) > new Date()){
					return item;
				}
				if(removeData){
					localStorage.removeItem(key);
				}
				return null;
			}
			return item;
		}
		return null;
	},
	remove(key){
		if(key){localStorage.removeItem(key);return}
		console.error('删除缓存错误：',key);
	}
	
}
//本地localStorage缓存相关 End

/*时间戳转成日期格式*/
var getLocalTime = function(nS) {
	try {
		var time = nS / 1000;
		return dateStr(new Date(parseInt(time) * 1000), "yyyy-MM-dd");
	} catch (e) {
		// 防止 ns等于2019-03-26这种格式
		return ns;
	}
}

//自定义时间格式
function timeStr(nS, str) {
	var time = nS / 1000;
	return dateStr(new Date(parseInt(time) * 1000), str);
}

// <summary>
// 格式化显示日期时间
// </summary>
// <param name="x">待显示的日期时间，例如new Date()</param>
// <param name="y">需要显示的格式，例如yyyy-MM-dd hh:mm:ss</param>
function dateStr(x, y) {
	var z = {
		y: x.getFullYear(),
		M: x.getMonth() + 1,
		d: x.getDate(),
		h: x.getHours(),
		m: x.getMinutes(),
		s: x.getSeconds()
	};
	return y.replace(/(y+|M+|d+|h+|m+|s+)/g, function(v) {
		return ((v.length > 1 ? "0" : "") + eval('z.' + v.slice(-1))).slice(-(v.length > 2 ? v.length : 2))
	});
}

// 时间戳转日期
var formatDate = function (value) {
    if (value != null) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d;
    } else {
        value = "";
    }

}

// 时间戳转日期
var formatDateTime = function (value) {
    if (value != null && value != "") {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m;
    } else {
        value = "";
    }

}

// 截取当前数据到小数点后两位，小数点后两位为0就直接去掉
var numFilter = function (value) {
    if(value===0){return 0};
    let realValNew;
    let realVal;
    //realVal = parseFloat(value).toFixed(2);
    if (value != null) {
        if (value >= 10000) {
            realValNew = value / 10000;
            realVal = realValNew.toFixed(2) + "亿";
        } else {
            realVal = parseFloat(value).toFixed(2) + "万";
        }

        var index = realVal.indexOf(".00");
        if (index != -1) {
            realVal = realVal.replace(".00", "");
        }
    } else {
        value = "";
    }
    return realVal;
}

//数组求和
Array.prototype.sum = function (fn) {
    var sum = 0.0;
    for (var i = 0; i < this.length; i++) {
        sum += Number(fn(this[i]));
    }
    return sum;
};

//数组取指定长度
Array.prototype.limit = function (size) {
    var end = size > this.length ? this.length : size;
    var list = new Array();
    for (var i = 0; i < end; i++) {
        list.push(this[i]);
    }
    return list;
};

//数组跳跃几位后取数据
Array.prototype.skip = function (start) {
    var list = new Array();
    if (this.length <= start) {
        return list;
    }
    for (var i = start; i < this.length; i++) {
        list.push(this[i]);
    }
    return list;
};
export {
    base
}




// WEBPACK FOOTER //
// ./src/common/js/base.js